/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * @hidden
 */
var AccessTokenValue = /** @class */ (function () {
    function AccessTokenValue(accessToken, idToken, expiresIn, homeAccountIdentifier) {
        this.accessToken = accessToken;
        this.idToken = idToken;
        this.expiresIn = expiresIn;
        this.homeAccountIdentifier = homeAccountIdentifier;
    }
    return AccessTokenValue;
}());
export { AccessTokenValue };
//# sourceMappingURL=AccessTokenValue.js.map


//////////////////
// WEBPACK FOOTER
// ./~/msal/lib-es6/cache/AccessTokenValue.js
// module id = 1989
// module chunks = 0